function enableDebugLogs() {
    return typeof localStorage !== 'undefined' && localStorage.getItem('enableDebugLogs') === 'true';
}

// biome-ignore lint/suspicious/noExplicitAny: accepted
export const trace: (...messageParts: any[]) => void = enableDebugLogs()
    ? (...args) => {
          if (import.meta.env.MODE !== 'test') {
              console.log('[debug]', ...args);
          }
      }
    : () => {};
